import { Box } from '@mui/material';
import { Allotment } from 'allotment';
import 'allotment/dist/style.css';
import { CodeEditorContainer } from './CodeEditorContainer';
import { ConsoleContainer } from './ConsoleContainer';

export function PyBasicCodingContent() {
  return (
    <Box
      component={Allotment}
      className="PyBasicCodingContent-root"
      sx={{
        flex: 1,
        width: '100%',
        '& .PyBasicCodingContent-content.x_left': {
          pr: '4px',
        },
        '& .PyBasicCodingContent-content.x_right': {
          pl: '4px',
        },
      }}
    >
      <Allotment.Pane minSize={100}>
        <CodeEditorContainer className="PyBasicCodingContent-content x_left" />
      </Allotment.Pane>
      <Allotment.Pane minSize={100}>
        <ConsoleContainer className="PyBasicCodingContent-content x_right" />
      </Allotment.Pane>
    </Box>
  );
}
